const gpsTrackerSteps = [
    "ALL_SKILLS_CERTIFICATES_APPROVED",
    "TRACKING_LOCATION_ACTIVE",
    "GPS_TRACKER_DISPATCHED",
    "UPLOAD_PACKAGE_PHOTO",
    "ENABLE_GPS_TRACKER",
    "SET_UP_SIM_NUMBER",
    "TRACKER_INSTALLED",
    "FTM_BACKGROUND_CHECK"
];

export default gpsTrackerSteps;